const DEFAULT_CSRF_COOKIE = "MC-CSRF";

const getCookieValue = (name: string): string | null => {
  if (typeof document === "undefined") {
    return null;
  }
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${encodeURIComponent(name)}=`));

  if (!match) {
    return null;
  }

  const value = match.substring(match.indexOf("=") + 1);
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const getCsrfToken = (): string | null => {
  const globalConfig = (window as typeof window & { __PUBLIC_CONFIG__?: Record<string, unknown> })
    .__PUBLIC_CONFIG__;
  const cookieName = typeof globalConfig?.csrfCookieName === "string" && globalConfig.csrfCookieName
    ? (globalConfig.csrfCookieName as string)
    : DEFAULT_CSRF_COOKIE;

  return getCookieValue(cookieName);
};

export const ensureCsrfToken = async (): Promise<string | null> => {
  const existing = getCsrfToken();
  if (existing) return existing;

  await fetch("/config.js", {
    credentials: "include",
    cache: "no-store",
    headers: {
      Accept: "application/javascript, text/javascript, */*",
      "X-Requested-With": "XMLHttpRequest"
    }
  }).catch(() => null);

  return getCsrfToken();
};
